import { CalculatorKey } from '@/ts/composables/useCalculator';

interface Measurement {
  name: string;
  key: CalculatorKey;
}

interface MeasurementGroup {
  groupName: string;
  measurements: Measurement[];
}

const MEASUREMENT_GROUPS: MeasurementGroup[] = [
  {
    groupName: 'PRICE',
    measurements: [
      { name: 'Performance', key: 'performance' },
      { name: '[Up Days] - [Down Days]', key: 'updown' }
    ]
  },
  {
    groupName: 'TECHNICALS',
    measurements: [
      { name: 'SCTR', key: 'sctr' },
      { name: 'RSI', key: 'rsi' },
      { name: 'PPO', key: 'ppo' },
      { name: 'Aroon Oscillator', key: 'aroon' },
      { name: 'Bollinger Band Width', key: 'bbwidth' },
      { name: 'Bollinger Band Position', key: 'bbposition' },
      { name: 'StochRSI', key: 'stochrsi' },
      { name: 'Full Stochastics', key: 'fullstoch' }
    ]
  }
];

export {
  MEASUREMENT_GROUPS
}

